import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { PageHeader, Form, Input, Button, Switch, Cascader, Typography, Spin, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

import * as ToolRequest from '../../tools/ToolRequest';

import SpinFull from '../../components/SpinFull';

const formLayout = {
  labelCol: {
    sm: { span: 5 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
  labelWrap: true,
};

const formTailLayout = {
  wrapperCol: {
    sm: { offset: 5, span: 16 },
  },
};

const { Title } = Typography;

export default function StationEditScreen(props) {
  const history = useHistory();
  const { stationId } = useParams();

  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [station, setStation] = useState(null);
  const [company, setCompany] = useState(null);

  const { metadata } = props;

  useEffect(() => {
    (async () => {
      const stationRes = await ToolRequest.request('GET', `/v1/station/${stationId}`);
      setStation({
        ...stationRes,
        companyId: [stationRes.companyId],
      });

      const companyRes = await ToolRequest.request('GET', `/v1/company/${stationRes.companyId}`);
      setCompany(companyRes);

      setLoaded(true);
    })();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const res = await ToolRequest.request('PUT', `/v1/station/${stationId}`, {
        displayName: values.displayName.trim(),
        deviceNo: isNaN(parseInt(values.deviceNo)) || values.deviceNo <= 0 ? null : parseInt(values.deviceNo),
        isEnabled: values.isEnabled,
      });

      message.success('Update Station successfully');

      history.push('/station');
    } catch (err) {
      setLoading(false);

      if (err?.response?.data) {
        switch (err.response.data) {
          case 'DUPLICATE_DEVICE_NO':
            return message.error('Device No is duplicate');
          default:
            return message.error('Unknown errors. Please retry');
        }
      }

      message.error('Unknown error. Please retry');
    }
  };

  return loaded ? (
    <PageHeader
      title={`Edit Station (${station.displayName})`}
      onBack={() => history.push(history.location.pathname.replace(/^\/station\/edit/, '/station/dashboard'))}
    >
      <Spin spinning={loading}>
        <Form
          {...formLayout}
          initialValues={station}
          onFinish={onFinish}
        >
          <Form.Item
            label="Company"
            name="companyId"
          >
            <Cascader
              options={[
                {
                  value: company.id,
                  label: `${company.displayName} (${company.name})`,
                },
              ]}
              disabled={true}
            />
          </Form.Item>

          <Form.Item
            label="Name"
            name="displayName"
            rules={[
              {
                required: true,
                message: 'Please enter the name',
              },
            ]}
          >
            <Input
              placeholder="Name"
            />
          </Form.Item>

          <Form.Item
            label="Device No"
            name="deviceNo"
          >
            <Input
              placeholder="Device No"
              type="number"
            />
          </Form.Item>

          <Form.Item
            label="Active"
            name="isEnabled"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>

          <Form.Item {...formTailLayout}>
            <Button type="primary" htmlType="submit" block>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </PageHeader>
  ) : <SpinFull />;
};
